<template>
    <div>
        <div v-if="show_group_lists">
            <el-table :data="groups" height="350" style="width: 100%">
                <el-table-column label="组织名称">
                    <template slot-scope="scope">
                        <span>{{ scope.row.group_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="进入">
                    <template slot-scope="scope">
                        <el-button size="mini" icon='el-icon-arrow-right' circle @click="showDuixianglists(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-else>
            <el-row style="margin:20px 0" type="flex" justify="center">
                <el-col :span="13">
                    <el-input v-model="duixiang_name_kw" @blur="searchByname(duixiang_name_kw)" @keyup.enter.native="searchByname(duixiang_name_kw)" @input="searchByname(duixiang_name_kw)" size="mini" placeholder="对象名关键字查找" />
                </el-col>
            </el-row>
            <el-row style="margin:20px 0">
                <Tag color="teal" @click.native="showAll">显示全部</Tag>
                <Tag v-for="(tag, index) in tags" checkable :checked="tag['is_checked'] ? true : false" @click.native="searchByTag(tag, index)" class="tag" color="#008080" :key="index">{{tag.tag_name}}</Tag>
                <el-table  :data="cur_page_duixiangs" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="50">
                    </el-table-column>
                    <el-table-column label="对象名">
                        <template slot-scope="scope">
                            <span>{{ scope.row.duixiang_name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标签">
                        <template slot-scope="scope">
                            <span v-for="item in scope.row.tags">
                                <el-tag class="el-tag" size="small" type="info">{{item.tag_name}} </el-tag type="info">
                            </span>
                        </template>
                    </el-table-column>
                    
                    
                </el-table>
                <div class="block">
                    <el-pagination :current-page="page.cur_page" :page-size="page.page_size" layout="prev, pager, next" :total="page.total" @current-change="currentChange">
                    </el-pagination>
                </div>
                <el-button type="success" @click="onSubmit">确认添加</el-button>
                <el-button type="text" @click="pageToList">查看和管理对象-></el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import config from '../../config.js';
import { Tag } from 'iview';

export default {

    data() {
        return {
            show_group_lists: true,
            groups: [],
            group: '',
            app: null,
            items: [],
            duixiangs: [],
            cur_page_duixiangs: [],
            page: {
                cur_page: 1,
                total: 0,
                page_size: 10

            },
            showing_duixiangs: [],
            duixiang_name_kw: '',
            tags: [],
            tags_ids: [],
            multipleSelection: []
        }
    },
    components: {
        Tag
    },
    props: ['app_id', 'from'],
    created() {
        this.checkLogin()
        console.log(this.app_id)
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        checkLogin() {
            let url = config.base_url + '/yun_table/users/islogin';
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data;
                if (res.login) {
                    console.log('login true');
                    this.getGroups()
                } else {
                    console.log('login false');
                    this.$router.push({
                        'path': '/login'
                    })
                }
            })

        },
        getGroups() {
            let _this = this;
            axios.get(config.base_url + '/yun_table/yun_duixiang_groups?excepted_app_id=' + this.app_id, {
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    }
                })
                .then(function(response) {
                    _this.groups = response.data;
                });
        },
        getApp() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                localStorage.setItem(response.data.app_id, JSON.stringify(response.data))
                this.setApp(res)
            }).catch((err) => {
                //console.log(err);
            })
        },
        setApp(app) {
            this.app = app

        },
        getDuixiang(group) {
            let url = config.base_url + '/yun_table/yun_duixiang?group_id=' + this.group.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.duixiangs = res
                this.page.total = res.length
                this.showing_duixiangs = res

                this.showCurDuixiang()
            })
        },
        showDuixianglists(group) {
            this.show_group_lists = false
            this.group = group
            this.getDuixiang(group)
            this.getTags(group)
            this.getApp()
            // let _this = this
            // axios.get(config.base_url + '/yun_table/yun_duixiang?group_id=' + group.group_id, {
            //         headers: {
            //             "Authorization": localStorage.getItem('token')
            //         }
            //     })
            //     .then(function(response) {
            //         _this.duixiangs = response.data;
            //     });
        },
        handleCheck() {

        },
        getTags(group) {
            //console.log('getTags')
            let url = config.base_url + '/yun_table/yun_duixiang_tags?group_id=' + group.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                this.tags = response.data
            })
        },
        showCurDuixiang() {
            let cur_page = this.page.cur_page
            //console.log(cur_page)
            let page_size = this.page.page_size
            let duixiangs = this.duixiangs
            let showing_duixiangs = this.showing_duixiangs
            this.cur_page_duixiangs = []
            if (showing_duixiangs.length > 0) {
                //cur_page = 1
                this.page.total = showing_duixiangs.length
                let cur_page_duixiangs = showing_duixiangs.slice((cur_page - 1) * page_size, (cur_page - 1) * page_size + page_size)
                this.cur_page_duixiangs = cur_page_duixiangs
            }


        },
        currentChange(cur_page) {
            //console.log(cur_page)
            this.page.cur_page = cur_page
            this.showCurDuixiang()

        },
        showAll() {
            //this.showing_duixiangs = []
            this.showing_duixiangs = this.duixiangs
            this.page.cur_page = 1
            this.showCurDuixiang()
            this.tags_ids = []
            for (let i = 0; i < this.tags.length; i++) {
                this.tags[i].is_checked = false
            }
        },
        searchByTag(tag, index) {
            let tags_ids = this.tags_ids
            let duixiangs = this.duixiangs
            this.page.cur_page = 1
            //console.log(index)
            function hasTag() {
                if (tags_ids.length > 0) {
                    for (let i = 0; i < tags_ids.length; i++) {
                        if (tags_ids[i] == tag.tag_id) {
                            return true
                        }
                    }
                }
                return false
            }
            if (hasTag()) {
                //console.log(index)
                this.tags_ids.splice(this.arrIndex(tag.tag_id, tags_ids), 1)
                this.tags[index].is_checked = false
                if (this.tags_ids.length < 1) {
                    this.showAll()
                    return false
                }

                //console.log(t)
            } else {
                this.tags_ids.push(tag.tag_id)
                this.tags[index].is_checked = true
            }
            this.showing_duixiangs = []
            for (let i = 0; i < duixiangs.length; i++) {
                if (duixiangs[i].tags.length < 1) {
                    continue;
                }
                let dx_tag_id = []
                for (let j = 0; j < duixiangs[i].tags.length; j++) {
                    dx_tag_id.push(duixiangs[i].tags[j].tag_id)
                    // if(this.inArray(duixiangs[i].tags[j].tag_id, tags_ids)){
                    //  this.showing_duixiangs.push(duixiangs[i])
                    // }
                }
                if (this.arrInArray(this.tags_ids, dx_tag_id)) {
                    this.showing_duixiangs.push(duixiangs[i])
                }

            }
            this.showCurDuixiang()

        },
        searchByname(kw) {
            //console.log(kw)
            if (!kw) {
                this.showAll()
                return false
            }
            let duixiangs = this.duixiangs
            this.page.cur_page = 1
            if (kw) {
                //this.cur_page_duixiangs = []
                this.showing_duixiangs = []
                let patten = new RegExp(kw)
                for (let i = 0; i < duixiangs.length; i++) {
                    if (patten.test(duixiangs[i].duixiang_name)) {
                        //this.cur_page_duixiangs.push(duixiangs[i])
                        this.showing_duixiangs.push(duixiangs[i])
                    }
                }
            }
            this.duixiang_name_kw = ''
            this.showCurDuixiang()

        },
        inArray(item, arr) {
            for (let i = 0; i < arr.length; i++) {
                if (item == arr[i]) {
                    return true
                }
            }
        },
        arrInArray(arr1, arr2) {
            if (arr1.length < 1) {
                return false
            }
            for (let i = 0; i < arr1.length; i++) {
                if (!this.inArray(arr1[i], arr2)) {
                    return false
                }
            }
            return true
        },
        arrIndex(item, arr) {
            for (let i = 0; i < arr.length; i++) {
                if (item == arr[i]) {
                    return i
                }
            }
            return -1
        },
        onSubmit(){
            let req_data = this.multipleSelection
            if(req_data.length == 0){
                this.$message({
                            message: '至少选择一个对象',
                            type: 'error'
                        })
                return false
            }
            for(let i=0; i<req_data.length;i++){
                let tags_ids = []
                for(let j=0; j<req_data[i].tags.length; j++){
                    tags_ids.push(req_data[i].tags[j].tag_id)
                }
                req_data[i].tags_ids = tags_ids
            }
            //console.log(this.from)
            if(this.from == 'jcdx'){
                var group_id = this.app.jcdx_group_id
            }
            if(this.from == 'jcry'){
                var group_id = this.app.jcry_group_id
            }
            axios({
                method: 'post',
                url: config.base_url + '/yun_table/yun_duixiang/batch_save?group_id=' + group_id,
                headers: {
                    "Authorization": localStorage.getItem('token')
                },
                data: req_data
            }).then((response) => {
                //console.log(response.status);
                this.$message({
                    message: '添加成功  ',
                    type: 'success'
                });
                

            }).catch((err) => {
                //console.log(err.response)
                let err_data = err.response.data.err_msg
                this.$message({
                    message: err_data,
                    type: 'error'
                })
            })
        },
        pageToList() {
            if(this.from == 'jcdx'){
                var group_id = this.app.jcdx_group_id
            }
            if(this.from == 'jcry'){
                var group_id = this.app.jcry_group_id
            }
            this.$router.push({
                name: 'duixianglists',
                params: {
                    group_id: group_id
                }
            })
            
        }

    }

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>